'use strict';

exports.__esModule = true;
exports.pageActions = exports.INSURERS_SEARCH_ITEM_ELEM_UPDATE = exports.INSURERS_DROPDOWN_ELEM_UPDATE = exports.SEARCH_BAR_HOLDER_OFFSET_UPDATE = undefined;

var _react = require('react');

var SEARCH_BAR_HOLDER_OFFSET_UPDATE = exports.SEARCH_BAR_HOLDER_OFFSET_UPDATE = 'HOME_PAGE:SEARCH_BAR_HOLDER_OFFSET_UPDATE';
var INSURERS_DROPDOWN_ELEM_UPDATE = exports.INSURERS_DROPDOWN_ELEM_UPDATE = 'HOME_PAGE:INSURERS_DROPDOWN_ELEM_UPDATE';
var INSURERS_SEARCH_ITEM_ELEM_UPDATE = exports.INSURERS_SEARCH_ITEM_ELEM_UPDATE = 'HOME_PAGE:INSURERS_SEARCH_ITEM_ELEM_UPDATE';

if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_pageActionsType', {
  value: require('react').PropTypes.shape({
    updateSearchBarHolderOffset: require('react').PropTypes.func.isRequired,
    updateInsurersDropdownElem: require('react').PropTypes.func.isRequired
  })
});
var pageActions = exports.pageActions = {
  updateSearchBarHolderOffset: function updateSearchBarHolderOffset(newOffset) {
    return {
      type: SEARCH_BAR_HOLDER_OFFSET_UPDATE,
      payload: {
        searchBarHolderOffset: newOffset
      }
    };
  },
  updateInsurersDropdownElem: function updateInsurersDropdownElem(newElem) {
    return {
      type: INSURERS_DROPDOWN_ELEM_UPDATE,
      payload: {
        insurersDropdownElem: newElem
      }
    };
  },
  updateSearchItemDropdownElem: function updateSearchItemDropdownElem(newElem) {
    return {
      type: INSURERS_SEARCH_ITEM_ELEM_UPDATE,
      payload: {
        searchItemDropdownElem: newElem
      }
    };
  }
};


// WEBPACK FOOTER //
// ./components/home-page/lib/actions/page.js